import * as Preact from "preact"

import "./DiceLayout.less"
import Dice from "@frog/source/data/games/dice/views/Dice.jsx"

export default function DiceLayout() {
    this.props.items[0] = this.props.items[0] ?? null
    this.props.items[1] = this.props.items[1] ?? null
    this.props.items[2] = this.props.items[2] ?? null
    this.props.items[3] = this.props.items[3] ?? null
    this.props.items[4] = this.props.items[4] ?? null
    this.props.items[5] = this.props.items[5] ?? null
    return (
        <div class="DiceLayout">
            {Object.keys(this.props.items).map((key) => {
                const item = this.props.items[key]
                return (
                    <Dice item={item} unit={this.props.unit} stage={this.props.stage}
                        isAnimated={item == this.props.equippedItem}
                        isHighlighted={item == this.props.equippedItem}
                        anchored={this.props.anchored}
                        index={key}/>
                )
            })}
        </div>
    )
}
